<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" :useAutoOptional="false" :optional="!rowboo" v-if="qx.update" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<!-- <Commonbtn backgroundColor="#FFF" title="查看" fontSize="14px" @btnclick="Look" :src="require('@/assets/icon/look.png')">
      </Commonbtn> -->
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Export"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.enabled" :title="secTitle" fontSize="14px" @btnclick="deactivate"
				:src="secImg">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.enabled" :title="seceTitle" fontSize="14px"
				@btnclick="deacteivate" :src="secImg">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
				title="导入" fontSize="14px" @getFile="seImport" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<Commondown key="u8" types="1" v-if="qx.setting" backgroundColor="#FFF" color="#E71D43" fontSize="14px"
				:datalist="downlist" @downs="downs" title="U8配置"></Commondown>
			<Commondown key="zz" backgroundColor="#FFF" color="#000" fontSize="14px" :datalist="LicenseRList"
				@downs="LicenseRLClick" types="2" title="证照相关"></Commondown>
			<Commondown types="2" backgroundColor="#FFF" fontSize="14px" fontSizeDowns="10px" :datalist="DowloadList"
				@downs="Dowload" title="下载模板" :src="require('@/assets/icon/icon-add.png')">
			</Commondown>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="手动维护经营省份" fontSize="14px"
				@btnclick="handShowProvince" :src="require('@/assets/icon/look.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="手动维护公司负责人" fontSize="14px"
				@btnclick="handShowCompanyBoss" :src="require('@/assets/icon/look.png')">
			</Commonbtn>
			<!-- <a class="Dowload" @click="SeconDowload">下载二级经销商导入模版</a> 
      <a class="Dowload" style="" @click="CityDowload">下载省市区列表信息</a> -->
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable @onRowClick="onRowClick" colnum=7 :tableData="tableData" :headerData="headerData"
				height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<DialogFrom width="640px" title="手动维护经营省份" :dialogVisible="provinceVisibles" @cancel="provinceBHcancel"
			@dialogOK="provinceBHdialogOK">
			<CommonbtnUpLoad style="display: inline-block;" backgroundColor="#FFF" title="导入" fontSize="14px"
				@getFile="importProvince" types="file" :src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a class="Dowload" @click="provinceDownloadTemplet">导入模版下载</a>
			<br />
			<template v-for="(item , index) of fromdatapadd">
				<Commondropdownlist ref="paddjxa" :btx="item.btx" :radio="item.radio" :widths="item.widths"
					:options="item.options" :key="index" :inputdata="item.inputdata" :title="item.title"
					:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
					:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
					:types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"
					:checkboxdata="item.checkboxdata" :disabled="item.disabled" :event="item.event"
					@invClass="handInvChange">
				</Commondropdownlist>
			</template>
		</DialogFrom>

		<DialogFrom width="640px" title="手动维护公司负责人" :dialogVisible="companyBossVisibles" @cancel="companyBossCancel"
			@dialogOK="companyBossDialogOK">
			<!-- <CommonbtnUpLoad v-if="qx.update" style="display: inline-block;" backgroundColor="#FFF" title="导入" fontSize="14px"
				@getFile="importCompanyBoss" types="file" :src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a v-if="qx.update" class="Dowload" @click="companyBossDownloadTemplet">导入模版下载</a>
			<br />-->
			<template v-for="(item , index) of fromdatacboss">
				<Commondropdownlist ref="cbossjxa" :btx="item.btx" :radio="item.radio" :widths="item.widths"
					:options="item.options" :key="index" :inputdata="item.inputdata" :title="item.title"
					:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
					:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
					:types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"
					:checkboxdata="item.checkboxdata" :disabled="item.disabled" :event="item.event"
					@invClass="handCbossInvChange">
				</Commondropdownlist>
			</template>
		</DialogFrom>

		<DialogFrom width="1000px" :title="licenceTitle" :OKASCAN="false" :dialogVisible="LicenseRLookdialogVisibles"
			@cancel="LicenseRLookcancel" @dialogOK="LicenseRLookdialogOK">
			<div class="LicenseRfrom" v-if="lflag">
				<div v-if="Tobereviewed">
					<Commonbtn backgroundColor="#FFF" title="全部审核" margin="0px 20px 20px 0px" fontSize="14px"
						@btnclick="AllReview" :src="require('@/assets/icon/shen.png')">
					</Commonbtn>
					<!-- v-if="license != null" -->
					<Commonbtn backgroundColor="#FFF" v-if="license != null" title="营业执照驳回" margin="0px 20px 20px 10px"
						fontSize="14px" @btnclick="businessLicense" :src="require('@/assets/icon/reject.png')">
					</Commonbtn>
					<!--  v-if="permission != null" -->
					<Commonbtn backgroundColor="#FFF" v-if="permission != null" title="医疗器械经营许可证驳回"
						margin="0px 20px 20px 10px" fontSize="14px" @btnclick="medicalEquipment"
						:src="require('@/assets/icon/reject.png')">
					</Commonbtn>
					<!-- v-if="record != null" -->
					<Commonbtn backgroundColor="#FFF" v-if="record != null" title="第二类医疗器械备案凭证驳回"
						margin="0px 20px 20px 10px" fontSize="14px" @btnclick="CLLMDFCR"
						:src="require('@/assets/icon/reject.png')">
					</Commonbtn>
					<Commondown v-if="RejectStatus" backgroundColor="#FFF" color="#000" fontSize="14px"
						:datalist="LicenseRejected" @downs="LicenseRejectedClick" types="2" title="证照驳回"></Commondown>
				</div>
				<!-- 营业执照 -->
				<License :license="license" @imgShowClick="imgShowClick"></License>
				<!-- 医疗器械经营许可证 -->
				<Permission :permission="permission" @imgShowClick="imgShowClick"></Permission>
				<!-- 第二类医疗器械备案凭证-->
				<Record :record="record" @imgShowClick="imgShowClick"></Record>
				<!-- 开户许可证 -->
				<PicturesType @See="See" :PicturesTypeData="openaccount" typeTitle="开户许可证"></PicturesType>
				<!-- 经销商信息表 -->
				<PicturesType @See="See" :PicturesTypeData="cusinfo" typeTitle="经销商信息表"></PicturesType>
				<!-- 业务员授权书 -->
				<PicturesType @See="See" :PicturesTypeData="salerbusinessauthority" typeTitle="业务员授权书"></PicturesType>
				<!-- 承诺函 -->
				<PicturesType @See="See" :PicturesTypeData="commitmentletter" typeTitle="承诺函"></PicturesType>
				<!-- 关联申明 -->
				<PicturesType @See="See" :PicturesTypeData="affiliatestatement" typeTitle="关联申明"></PicturesType>
				<!-- 联系信息 -->
				<InfoturesType @See="See" :InfoturesTypeData="filecontact" typeTitle="联系信息"></InfoturesType>
				<!-- 仅授权说明文件 -->
				<PicturesType v-if="providerDocumentation&&providerDocumentation.lstAttachment!=null" @See="See"
					:PicturesTypeData="providerDocumentation" typeTitle="仅授权说明文件"></PicturesType>
			</div>
		</DialogFrom>
		<DialogFrom width="640px" title="营业执照驳回原因" :dialogVisible="licenseBHdialogVisibles" @cancel="licenseBHcancel"
			@dialogOK="licenseBHdialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonLicense">
			</el-input>
		</DialogFrom>

		<DialogFrom width="640px" title="医疗器械经营许可证驳回原因" :dialogVisible="permissionBHdialogVisibles"
			@cancel="permissionBHcancel" @dialogOK="permissionBHdialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonPermission">
			</el-input>
		</DialogFrom>

		<DialogFrom width="640px" title="第二类医疗器械备案凭证驳回原因" :dialogVisible="recordBHdialogVisibles"
			@cancel="recordBHcancel" @dialogOK="recordBHdialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonRecord">
			</el-input>
		</DialogFrom>

		<DialogFrom width="1000px" title="驳回原因" :dialogVisible="RejectReasondialogVisibles" @cancel="RejectReasoncancel"
			@dialogOK="RejectReasondialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonPic" style="width: 600px;">
			</el-input>
		</DialogFrom>

		<DialogFrom width="1000px" title="驳回列表" :dialogVisible="rejectdialogVisibles" @cancel="rejectcancel"
			@dialogOK="rejectdialogOK">
			<Commontable @onRowClick="rejectdonRowClick" width="1000px" colnum=7 :tableData="rejectTable"
				:headerData="rejectHeaderData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="rejecthandleCurrentChange" @handleSizeChange="rejecthandleSizeChange"
					:total="rejecttotal"></Pagination>
			</div>
			<div class="detailedCss">{{ detailsTitle }}明细</div>
			<!-- 营业执照驳回列表 -->
			<LicenseRejectList :RejectListProps="BLdetailsTableData" v-if="BLdetailsTableData != null"
				@imgShowClick="imgShowClick"></LicenseRejectList>
			<!-- 医疗器械经营许可证 -->
			<BusinessRejectList :RejectListProps="BusdetailsTableData" v-if="BusdetailsTableData != null"
				@imgShowClick="imgShowClick"></BusinessRejectList>
			<!-- 第二类医疗器械备案凭证 -->
			<ClassIIMedicalRejectList :RejectListProps="RedetailsTableData" v-if="RedetailsTableData != null"
				@imgShowClick="imgShowClick"></ClassIIMedicalRejectList>
			<!-- 承诺函 -->
			<PicTypeRejectList :PicTypeRejectListProps="CommitmentLetterData" v-if="CommitmentLetterData != null"
				@See="See"></PicTypeRejectList>
			<!-- 开户许可证 -->
			<PicTypeRejectList :PicTypeRejectListProps="openaccountData" v-if="openaccountData != null" @See="See">
			</PicTypeRejectList>
			<!-- 经销商信息表 -->
			<PicTypeRejectList :PicTypeRejectListProps="cusinfoData" v-if="cusinfoData != null" @See="See">
			</PicTypeRejectList>
			<!-- 业务员授权书 -->
			<PicTypeRejectList :PicTypeRejectListProps="salerbusinessauthorityData"
				v-if="salerbusinessauthorityData != null" @See="See"></PicTypeRejectList>
			<!-- 关联申明 -->
			<PicTypeRejectList :PicTypeRejectListProps="affiliatestatementData" v-if="affiliatestatementData != null"
				@See="See"></PicTypeRejectList>
			<!-- 联系信息 -->
			<infoUserTypeRejectList :InfoturesTypeRejectListData="filecontactData" v-if="filecontactData != null">
			</infoUserTypeRejectList>
		</DialogFrom>
		<DialogFrom width="1100px" title="新增二级经销商档案" :dialogVisible="dialogVisibles" @cancel="cancel"
			@dialogOK="dialogOK">
			<el-tabs v-model="activeName" type="card">
				<el-tab-pane label="基本信息" name="first">
					<div class="from">
						<template v-for="(item , index) of fromdataadd">
							<Commondropdownlist ref="addjxa" :btx="item.btx" :radio="item.radio" :widths="item.widths"
								:options="item.options" :key="index" :inputdata="item.inputdata" :title="item.title"
								:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
								:radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
								:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
								:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
								:disabled="item.disabled" :pt="item.pt" @province="province" @city="city"
								@remoteMethod="remoteMethod" @handleCheckedCitiesChange="handleCheckedAddChange">
							</Commondropdownlist>
						</template>
						<Commondropdownlist style="margin-left:205px;"
							@handleCheckedCitiesChangets="(e)=>boxsdataInvClass = e" :boxsdata="boxsdataInvClass"
							:checkboxdata="checkboxets" title="产品线" fontSize="14px" color="#333333" types=""
							inputtype="checkboxets"></Commondropdownlist>
					</div>
				</el-tab-pane>
				<el-tab-pane label="公司信息" name="second">
					<div class="from">
						<template v-for="(item , index) of fromdataadd2">
							<Commondropdownlist ref="addjxa2" :btx="item.btx" :radio="item.radio" :widths="item.widths"
								:options="item.options" :key="index" :inputdata="item.inputdata" :title="item.title"
								:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
								:radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
								:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
								:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
								:disabled="item.disabled">
							</Commondropdownlist>
						</template>
					</div>
				</el-tab-pane>
			</el-tabs>
		</DialogFrom>
		<DialogFrom width="1100px" :title=EidtTitle :dialogVisible="dialogVisiblesedit" @cancel="canceledit"
			@dialogOK="dialogOKedit">
			<el-tabs v-model="activeName" type="card">
				<el-tab-pane label="基本信息" name="first">
					<div class="from">
						<template v-for="(item , index) of fromdataedit">
							<Commondropdownlist ref="secupdate" :btx="item.btx" :radio="item.radio"
								:widths="item.widths" :options="item.options" :key="index" :inputdata="item.inputdata"
								:title="item.title" :fontSize="item.fontSize" :color="item.color"
								:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2"
								:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
								:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"
								:checkboxdata="item.checkboxdata" :disabled="item.disabled" :pt="item.pt"
								@province="province" @city="city" @remoteMethod="remoteMethod"
								@handleCheckedCitiesChange="handleCheckedEditChange">
							</Commondropdownlist>
						</template>
						<Commondropdownlist style="margin-left:205px;"
							@handleCheckedCitiesChangets="(e)=>boxsdataInvClass = e" :boxsdata="boxsdataInvClass"
							:checkboxdata="checkboxets" title="产品线" fontSize="14px" color="#333333" types=""
							inputtype="checkboxets"></Commondropdownlist>
					</div>
				</el-tab-pane>
				<el-tab-pane label="公司信息" name="second">
					<div class="from">
						<template v-for="(item , index) of fromdataedit2">
							<Commondropdownlist ref="secupdate2" :btx="item.btx" :radio="item.radio"
								:widths="item.widths" :options="item.options" :key="index" :inputdata="item.inputdata"
								:title="item.title" :fontSize="item.fontSize" :color="item.color"
								:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2"
								:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
								:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"
								:checkboxdata="item.checkboxdata" :disabled="item.disabled" @province="province"
								@city="city">
							</Commondropdownlist>
						</template>
					</div>
				</el-tab-pane>
			</el-tabs>
		</DialogFrom>

		<DialogFrom width="1000px" title="U8配置" :dialogVisible="dialogVisiblesU8" @cancel="cancelU8"
			@dialogOK="dialogOKeditU8">
			<div class="from">
				<template v-for="(item , index) of fromdataU8">
					<Commondropdownlist ref="U8secondRefs" :key="index" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
						:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min"
						:max="item.max">
					</Commondropdownlist>
				</template>
			</div>
			<div style="width: 952px;height: 1px;background-color: #F0F0F0;margin-top: 30px;"></div>
			<div style="width: 952px;">
				<Commonbtn backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="U8add"
					:src="require('@/assets/icon/icon-add.png')">
				</Commonbtn>
				<Commonbtn backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="U8del"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
				<div style="width: 100%;">
					<Commontable @handleSelectionChange="handleSelectionChange" width="1000px" colnum=5
						:tableData="tableU8Data" :headerData="headerData1" height="100%">
					</Commontable>
				</div>
			</div>
		</DialogFrom>

		<DialogFrom width="640px" title="导入U8配置" :dialogVisible="dialogVisiblesU8d" @cancel="cancelU8d"
			@dialogOK="dialogOKeditU8d">
			<div style="width: 952px;">
				<CommonbtnUpLoad style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF" title="U8配置导入"
					fontSize="14px" @getFile="U8Import" types="file" :src="require('@/assets/icon/icon-drjys.png')">
				</CommonbtnUpLoad>
				<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
					@click="u8DowloadImporttemplate">U8配置导入模版下载</a>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条档案吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要{{secTitle}}这条档案吗？</span>
		</Dialog>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogeVisibledeactivate"
			@cancel="dialogeVisibledeactivate = false" @dialogOK="dialogeOKdeactivate"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要{{seceTitle}}这条档案吗？</span>
		</Dialog>
		<Picturepreview :imgsrc="imgsrc" :show="imgShow" @hidefn="imgHide"></Picturepreview>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import Picturepreview from '../../../../components/picturepreview.vue'
	import fromdata from '../fromData/add'
	import fromdata2 from '../fromData/add2'
	import fromdataedit from '../fromData/edit'
	import fromdataedit2 from '../fromData/edit2'
	import frompdata from '../fromData/province'
	import Dialog from '../../../../components/dialog.vue'
	import Commondown from '../../../../components/common-down.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import headerData from '../tableData/headerData'
	import rejectHeaderData from '../tableData/rejectHeaderData'
	import BLdetailstable from '../tableData/BLdetailstable'
	import Record from './components/record.vue'
	import Permission from './components/permission.vue'
	import License from './components/license.vue'
	import PicturesType from './components/PicturesType.vue'
	import PicTypeRejectList from './components/PicType-rejectList.vue'
	import infoUserTypeRejectList from './components/infoUserType-rejectList.vue'
	import InfoturesType from './components/InfoturesType.vue'
	import LicenseRejectList from './components/license-rejectList.vue'
	import BusinessRejectList from './components/business-rejectList.vue'
	import ClassIIMedicalRejectList from './components/ClassIIMedical-rejectList.vue'
	import {
		CustomerInfo,
		CustomerAdd,
		CustomerEdit,
		CustomerDelete,
		BCustomerSetActive,
		SetCooperateStatus,
		BaOrganizationList,
		GetCusType,
		GetProvince,
		GetCity,
		GetDistrict,
		CustomerImport,
		CustomerDownloadTemplet,
		CustomerU8MatchList,
		CustomerAddU8Match,
		CustomerDeleteU8Match,
		CustomerImportU8Match,
		CusType,
		CustomerDownloadU8MatchTemplet,
		CustomeDownloadAreaListr,
		InventoryClassList,
		LicenseGetAllLicense,
		LicenseRejectBusinessLicense,
		LicenseRejectBusinessPermission,
		LicenseRejectBusinessRecord,
		LicenseVerifyLicense,
		LicenseGetRejectLicense,
		LicenseGetBusinessLicense,
		LicenseGetBusinessPermission,
		LicenseGetBusinessRecord,
		OpenAccountReject,
		CustomerList
	} from '@/api/home'
	import {
		OpenAccountGetCommitmentLetter,
		OpenAccountGetOpenAccount,
		OpenAccountGetCusInfo,
		OpenAccountGetAffiliateStatement,
		OpenAccountGetSalerBusinessAuthority,
		OpenAccountGetFileContact,
		//省份相关
		GetCustomerProvinceID,
		EditCustomerProvinceID,
		DownloadImportProvinceTemplet,
		ImportProvinceData,
		HelperRegionMan,
		GetHelperProvinceMan,
		//公司负责人相关
		GetBOSSNameByInvClass,
		SetBOSSNameByInvClass
	} from '@/api/channel'

	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown,
			CommonbtnUpLoad,
			Picturepreview,
			Record,
			Permission,
			License,
			PicturesType,
			PicTypeRejectList,
			InfoturesType,
			LicenseRejectList,
			BusinessRejectList,
			ClassIIMedicalRejectList,
			infoUserTypeRejectList
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
				activeName: 'first',
				providerDocumentation: {
					lstAttachment: null,
				},
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				dialogVisiblesU8: false,
				dialogVisiblesU8d: false,
				dialogVisiblesdrjg: false,
				LicenseRLookdialogVisibles: false,
				licenseBHdialogVisibles: false,
				permissionBHdialogVisibles: false,
				recordBHdialogVisibles: false,
				rejectdialogVisibles: false,
				RejectReasondialogVisibles: false,
				rightboo: false,
				dwonleft: false,
				rowboo: false,
				lflag: false,
				imgflag: false,
				Tobereviewed: false,
				imgsrc: '',
				imgShow: false,
				RejectStatus: true,
				rejecttotal: null,
				ptype: '',
				licenceTitle: '查看有效证照',
				CompanyID: '',
				getID: '',
				CusTypestate: -1,
				DowloadList: [{
						title: '下载二级经销商导入模版',
						flag: true
					},
					{
						title: '下载省市区列表信息',
						flag: true
					},
				],
				LicenseRejected: [{
						title: '开户许可证',
						flag: true
					},
					{
						title: '经销商信息表',
						flag: true
					},
					{
						title: '业务员授权书',
						flag: true
					},
					{
						title: '承诺函',
						flag: true
					},
					{
						title: '关联申明',
						flag: true
					},
					{
						title: '联系信息',
						flag: true
					},
				],
				fromdataadd: [],
				fromdataadd2: [],
				fromdataedit: [],
				fromdataedit2: [],
				fromdatapadd: [],
				tableDatadrjg: [],
				tableU8Data: [],
				U8IDsData: [],
				boxsdataInvClass: [],
				checkboxets: [],
				rejectTable: [],
				BLdetailstable: [],
				openaccount: null,
				cusinfo: null,
				salerbusinessauthority: null,
				commitmentletter: null,
				affiliatestatement: null,
				filecontact: null,
				BLdetailsTableData: null,
				BusdetailsTableData: null,
				RedetailsTableData: null,
				CommitmentLetterData: null,
				openaccountData: null,
				cusinfoData: null,
				salerbusinessauthorityData: null,
				affiliatestatementData: null,
				filecontactData: null,
				RejectpageSize: 10,
				Rejectpageindex: 1,
				cusCode: '',
				AEflig: 1,
				title: '',
				RejectReasonPermission: "",
				RejectReasonLicense: '',
				RejectReasonRecord: '',
				RejectReasonPic: "",
				detailsTitle: '',
				RejectedIndex: '', //记录驳回下拉框的index
				EidtTitle: '',
				secImg: require('@/assets/icon/icon-stop.png'),
				secTitle: "停用",
				seceTitle: "停止合作",
				from: {
					cusCode: "",
					cusName: "",
					cusType: 0,
					cusEName: "",
					actived: null,
					cusAbbName: "",
					provinceID: 0,
					cityID: 0,
					districtID: 0,
					address: "",
					linkMan: "",
					linkPhone: "",
					licenseNo: "",
					licenseVDate: "",
					licenseMDate: "",
					voucherNo: "",
					voucherMDate: "",
					voucherVDate: "",
					companyInCharge: "",
					businessAddress: "",
					companyInLaw: "",
					warehouseAddress: "",
					parentId: "",
					Mobile: "",
					Email: "",
					NoStockInApp: ''
				},
				fromdataU8: [{
					inputdata: '',
					title: 'U8账套',
					fontSize: '14px',
					color: '#333333',
					placeholder: '请输入',
					types: 'text',
					inputtype: 'input',
					width: '210px',
					lablewith: '55px'
				}, {
					inputdata: '',
					title: 'U8编号',
					fontSize: '14px',
					color: '#333333',
					placeholder: '请输入',
					types: 'text',
					inputtype: 'input',
					width: '210px',
				}, ],
				headerData: [

				],
				rejectHeaderData: [],
				tableData1: [{
						kong: '',
						U8id: '2',
						U8number: '102100024',
					},
					{
						kong: '',
						U8id: '3',
						U8number: '102100024',
					},
				],
				headerData1: [{
						prop: 'AccID',
						label: 'U8账套',
						columnwidth: 400,

					},
					{

						prop: 'U8Code',
						label: 'U8编号',
						columnwidth: 522
					},
				],
				downlist: [{
						title: 'U8配置'
					},
					{
						title: '导入U8配置'
					},
				],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false,
					License: false, //证照
				},
				LicenseRList: [{
					title: '查看有效证照',
					flag: true
				}],
				LicenseRLists: [{
						title: '查看有效证照',
						flag: true
					},
					{
						title: '查看待审核证照',
						flag: true
					},
					{
						title: '查看历史驳回证照',
						flag: true
					}
				],
				UnVerifyLicenseCount: null, //待审核证照数量
				ValidLicenseCount: null, //有效证照数量
				RejectLicenseCount: null, //被驳回证照数量
				license: null, //营业执照部分
				permission: null, //医疗器械经营许可证部分
				record: null, //第二类医疗器械备案凭证部分
				status: null,
				enabled: 1,
				RejectReason: "", //驳回原因
				provinceVisibles: false,
				companyBossVisibles: false,
				fromdatacboss: [{
					inputdata: "",
					title: "产品线",
					fontSize: "14px",
					color: "#333333",
					placeholder: "全部",
					types: "",
					inputtype: "select",
					width: "350px",
					lablewith: "100px",
					btx: true,
					options: [],
					event: "invClass",
				}, {
					inputdata: "",
					title: "公司负责人",
					fontSize: "14px",
					color: "#333333",
					placeholder: "请输入",
					types: "text",
					inputtype: "input",
					width: "350px",
					lablewith: "100px",
					btx: true,
				}],
				dialogeVisibledeactivate: false,
			}
		},
		mounted() {
			this.BLdetailstable = JSON.parse(JSON.stringify(BLdetailstable))
			this.rejectHeaderData = JSON.parse(JSON.stringify(rejectHeaderData))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataadd2 = JSON.parse(JSON.stringify(fromdata2))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.fromdataedit2 = JSON.parse(JSON.stringify(fromdataedit2))
			this.QX()
			this.getCusType()
			this.CusType()
		},
		methods: {
			//打开选择省份
			async handShowProvince() {
				if (!this.cusCode) {
					this.$message.error('请选中一行数据');
					return;
				}
				this.fromdatapadd = JSON.parse(JSON.stringify(frompdata))
				let res1 = await InventoryClassList({});
				if (res1.code == 0) {
					this.fromdatapadd[0].options = [];
					res1.data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName,
						};
						this.fromdatapadd[0].options.push(obj);
					});
				}
				let res2 = await GetProvince({});
				if (res2.code == 0) {
					this.fromdatapadd[1].options = [];
					res2.data.map((item, index) => {
						let obj = {
							key: Number(item.Value),
							value: item.Text,
						};
						this.fromdatapadd[1].options.push(obj);
					});
				}
				this.provinceVisibles = true;
			},
			//打开选择公司负责人
			async handShowCompanyBoss() {
				if (!this.cusCode) {
					this.$message.error('请选中一行数据');
					return;
				}
				this.$refs.cbossjxa && this.$refs.cbossjxa.map(item => {
					item.modelvalue = '';
				});
				let res1 = await InventoryClassList({});
				if (res1.code == 0) {
					this.fromdatacboss[0].options = [];
					res1.data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName,
						};
						this.fromdatacboss[0].options.push(obj);
					});
				}
				this.companyBossVisibles = true;
			},
			//公司负责人产品线改变
			async handCbossInvChange(e) {
				let {
					data,
					code,
					message
				} = await GetBOSSNameByInvClass({
					CusCode: this.cusCode,
					InvClass: e.modelvalue
				})
				if (code == 0) {
					this.$refs.cbossjxa[1].modelvalue = data;
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			companyBossCancel() {
				this.companyBossVisibles = false;
				if (this.$refs.cbossjxa) {
					this.$refs.cbossjxa[0].modelvalue = '';
					this.$refs.cbossjxa[1].modelvalue = '';
				}
			},
			//提交公司负责人
			async companyBossDialogOK() {
				let {
					data,
					code,
					message
				} = await SetBOSSNameByInvClass({
					CusCode: this.cusCode,
					InvClass: this.$refs.cbossjxa[0].modelvalue,
					BOSSName: this.$refs.cbossjxa[1].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '编辑成功'
					});
					this.companyBossCancel();
					this.$parent.customerList();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 导入公司负责人 (暂未实现)
			async importCompanyBoss(file) {
				this.$message.warning('该功能暂未开放');
			},
			// 下载导入模板公司负责人 (暂未实现)
			async companyBossDownloadTemplet() {
				this.$message.warning('该功能暂未开放');
			},
			//产品线改变
			async handInvChange(e) {
				let res = await HelperRegionMan({
					InvClass: e.modelvalue
				})
				if (res.code == 0) {
					this.fromdatapadd[2].options = res.data;
				} else {
					this.$message.error(res.message);
				}

				let ress = await GetHelperProvinceMan({
					InvClass: e.modelvalue
				})
				if (ress.code == 0) {
					this.fromdatapadd[3].options = ress.data;
				} else {
					this.$message.error(ress.message);
				}
				let {
					data,
					code,
					message
				} = await GetCustomerProvinceID({
					CusCode: this.cusCode, //'1022328', //
					InvClass: e.modelvalue
				})
				if (code == 0) {
					this.$refs.paddjxa[1].modelvalue = data.ProvinceIDs;
					this.$refs.paddjxa[2].modelvalue = data.Managers;
					this.$refs.paddjxa[3].modelvalue = data.ProvinceManagers;
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			provinceBHcancel() {
				this.provinceVisibles = false;
				this.$refs.paddjxa[0].modelvalue = '';
				this.$refs.paddjxa[1].modelvalue = '';
				this.$refs.paddjxa[2].modelvalue = '';
				this.$refs.paddjxa[3].modelvalue = '';
			},
			//提交
			async provinceBHdialogOK() {
				let {
					data,
					code,
					message
				} = await EditCustomerProvinceID({
					CusCode: this.cusCode, //'1022328', //
					InvClass: this.$refs.paddjxa[0].modelvalue,
					ProvinceInputIds: this.$refs.paddjxa[1].modelvalue,
					userNames: this.$refs.paddjxa[2].modelvalue,
					ProvinceManagers: this.$refs.paddjxa[3].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '编辑成功'
					});
					this.provinceBHcancel();
					this.$parent.customerList();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 导入
			async importProvince(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await ImportProvinceData(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						if (res.data.length > 0) {
							this.dialogVisiblesdrjg = true
							this.tableDatadrjg = res.data
							this.title = "导入结果"
						}
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					loading.close();
				}
			},
			// 下载导入模板
			async provinceDownloadTemplet() {
				let {
					data,
					code,
					message
				} = await DownloadImportProvinceTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 33) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 38) {
								this.qus = items.Nodes
							}
						})
					}
					// console.log(this.qus, 'this.qus');
				})
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'setting') {
							this.qx.setting = true
						} else if (item.NodeName == 'License') {
							this.qx.License = true
							this.LicenseRList = this.LicenseRLists
						}
					})
				}
			},
			//下载模板
			Dowload(index) {
				if (index == 0) {
					this.SeconDowload()
				}
				if (index == 1) {
					this.CityDowload("经销商引入评估")
				}
			},
			imgShowClick(URL) {
				console.log(URL);
				this.imgShow = true
				this.imgsrc = URL
			},
			imgHide() {
				this.imgShow = false
			},
			ImgMouseover(e) {
				this.imgflag = true
			},
			ImgMouseout(e) {
				this.imgflag = false
			},
			// 导入
			async customerImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await CustomerImport(formData)
					if (res.code == 0) {

						this.$message({
							type: 'success',
							message: res.message
						})
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					loading.close();
				}
			},
			// 导入
			seImport(file) {
				this.customerImport(file)
			},
			// 下载导入模板
			async customerDownloadTemplet() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await CustomerDownloadTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			SeconDowload() {
				this.customerDownloadTemplet()
			},
			async customeDownloadAreaListr() {
				let {
					data,
					code,
					message
				} = await CustomeDownloadAreaListr({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			CityDowload() {
				this.customeDownloadAreaListr()
			},
			// 判断一二级经销商
			async CusType() {
				let {
					code,
					data
				} = await CusType({})
				if (code == 0) {
					if (data.CusType == "平台") {
						this.CusTypestate = 1
					}
					if (data.CusType == "经销商") {
						this.CusTypestate = 0
					}
				}
			},
			// U8配置列表
			async customerU8MatchList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await CustomerU8MatchList({
					code: this.cusCode
					// code: this.CompanyID //admin测试参数
				})
				if (code == 0) {
					this.tableU8Data = data.data
					loading.close();
				}
				loading.close();
			},
			// 新增
			async customerAddU8Match() {
				if (this.$refs.U8secondRefs[0].modelvalue == "") {
					this.$message({
						type: "warning",
						message: "U8账套不能为空"
					})
					return false
				}
				if (this.$refs.U8secondRefs[1].modelvalue == "") {
					this.$message({
						type: "warning",
						message: "U8编号不能为空"
					})
					return false
				}
				let {
					code,
					message
				} = await CustomerAddU8Match({
					Code: this.cusCode,
					// Code: this.CompanyID, //admin测试参数
					AccID: this.$refs.U8secondRefs[0].modelvalue,
					U8Code: this.$refs.U8secondRefs[1].modelvalue,

				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: "新增成功"
					})
					this.customerU8MatchList()
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
				this.$refs.U8secondRefs.map((item, index) => {
					item.modelvalue = ""
				})
			},
			// U8配置新增
			U8add() {
				this.customerAddU8Match()
			},
			// 删除
			async customerDeleteU8Match() {
				let arrIDs = []
				this.U8IDsData.map((item, index) => {
					arrIDs.push(item.ID)
				})
				let {
					code,
					message
				} = await CustomerDeleteU8Match({
					IDs: arrIDs
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					})
					this.customerU8MatchList()
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
			},
			// U8配置删除
			U8del() {
				this.customerDeleteU8Match()
			},
			// 导入
			async customerImportU8Match(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await CustomerImportU8Match(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						if (res.data.length > 0) {
							this.dialogVisiblesdrjg = true
							this.tableDatadrjg = res.data
							this.title = "导入结果"
						}
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					loading.close();
				}
			},
			U8Import(file) {
				this.customerImportU8Match(file)
			},
			handleSelectionChange(val) {
				this.U8IDsData = val
			},
			// 省
			async getProvince() {
				let {
					code,
					data
				} = await GetProvince({})
				if (code == 0) {
					if (this.AEflig == 1) {
						this.fromdataadd[5].options = []
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text
							}
							this.fromdataadd[5].options.push(obj)
						})
					}
					if (this.AEflig == 2) {
						this.fromdataedit[5].options = []
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text
							}
							this.fromdataedit[5].options.push(obj)
						})
					}
				}
			},
			// 市
			async getcity(provinceid) {
				let params = {
					ProvinceID: provinceid
				}
				let {
					code,
					data
				} = await GetCity({
					params
				})
				if (code == 0) {
					if (this.AEflig == 1) {
						this.fromdataadd[6].options = []
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text
							}
							this.fromdataadd[6].options.push(obj)
						})
					}
					if (this.AEflig == 2) {
						this.fromdataedit[6].options = []
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text
							}
							this.fromdataedit[6].options.push(obj)
						})
					}
				}
			},
			// 区
			async getDistrict(cityID) {
				let params = {
					CityID: cityID
				}
				let {
					code,
					data
				} = await GetDistrict({
					params
				})
				if (code == 0) {
					if (this.AEflig == 1) {
						this.fromdataadd[7].options = []
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text
							}
							this.fromdataadd[7].options.push(obj)
						})
					}
					if (this.AEflig == 2) {
						this.fromdataedit[7].options = []
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text
							}
							this.fromdataedit[7].options.push(obj)
						})
					}
				}
			},
			//上级经销商的下拉
			async getCusType() {
				let {
					code,
					data
				} = await GetCusType({

				})
				//console.log('datassss', data, code)
				if (code == 0) {
					this.fromdataadd[2].options = []
					this.fromdataedit[2].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.fromdataedit[2].options.push(obj)
						this.fromdataadd[2].options.push(obj)

					})
					//console.log(this.fromdataedit[2].options)
				}

			},

			//上级经销商的下拉
			async baOrganizationList() {
				let {
					code,
					data
				} = await BaOrganizationList({
					// pageSize: 20,
					// pageIndex: 1,
					CusGrade: 1,
					actived: 1
				})
				//console.log('data', data, code)
				if (code == 0) {
					this.fromdataadd[4].options = []
					this.fromdataedit[4].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CompanyID,
							value: item.CompanyName
						}
						this.fromdataadd[4].options.push(obj)
						this.fromdataedit[4].options.push(obj)

					})
				}
			},
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.checkboxets = []
					data.data.map((item, index) => {
						let obj = {
							label: item.InvClass,
							value: item.InvClassName
						}
						this.checkboxets.push(obj)
					})
				}
			},
			async remoteMethod(query = '') {
				let {
					code,
					data
				} = await CustomerList({
					cusName: query
				})
				if (code == 0) {
					this.fromdataadd[23].options = []
					this.fromdataedit[23].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName,
						}
						this.fromdataadd[23].options.push(obj)
						this.fromdataedit[23].options.push(obj)
					})
				}
			},
			// 新增
			async customerAdd() {
				console.log(this.$refs.addjxa[22].modelvalue)
				if (this.boxsdataInvClass.length < 0) {
					this.$message({
						type: "warning",
						message: "产品至少选一个"
					})
					return
				}
				let {
					code,
					message
				} = await CustomerAdd({
					cusCode: this.from.cusCode,
					cusName: this.from.cusName,
					cusType: Number(this.from.cusType),
					cusEName: this.from.cusEName,
					actived: Number(this.from.actived),

					cusAbbName: this.from.cusAbbName,
					provinceID: Number(this.from.provinceID),
					cityID: Number(this.from.cityID),
					districtID: Number(this.from.districtID),

					address: this.from.address,
					licenseNo: this.from.licenseNo,
					licenseVDate: this.from.licenseVDate,
					licenseMDate: this.from.licenseMDate,

					voucherNo: this.from.voucherNo,
					voucherMDate: this.from.voucherMDate,
					voucherVDate: this.from.voucherVDate,
					businessAddress: this.from.businessAddress,

					companyInLaw: this.from.companyInLaw,
					warehouseAddress: this.from.warehouseAddress,
					parentId: this.from.parentId ? this.from.parentId.join(',') : '',

					Mobile: this.from.Mobile,
					Email: this.from.Email,
					NoStockInApp: this.from.NoStockInApp,
					invClassList: this.boxsdataInvClass,

					FileLinkMan: this.from.FileLinkMan,
					FileLinkTel: this.from.FileLinkTel,
					FileEMail: this.from.FileEMail,
					FileReceiveAddress: this.from.FileReceiveAddress,
					BuyFromHome: this.from.BuyFromHome,
					CompanyChargeName: this.from.CompanyChargeName,
					CompanyChargePhone: this.from.CompanyChargePhone,
					CompanyChargeEmail: this.from.CompanyChargeEmail,
					DataUploadName: this.from.DataUploadName,
					DataUploadPhone: this.from.DataUploadPhone,
					DataUploadEmail: this.from.DataUploadEmail,
					DeliveryName: this.from.DeliveryName,
					DeliverPhone: this.from.DeliverPhone,
					DeliveryAddress: this.from.DeliveryAddress,
					InvoiceName: this.from.InvoiceName,
					InvoicePhone: this.from.InvoicePhone,
					InvoiceAddress: this.from.InvoiceAddress,
					IsProvider: this.from.IsProvider,
					lstParentCodes: this.from.lstParentCodes
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '新增成功'
					});
					this.rowboo = false
					this.$parent.customerList()
					this.$refs.addjxa.map((item, index) => {
						if (index == 9) {
							item.radio = "1"
						}
						item.modelvalue = ""
					})
					this.$refs.addjxa2.map((item, index) => {
						if (index == 4) {
							item.radio = "1"
						}
						item.modelvalue = ""
					})
					this.dialogVisibles = false
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 详情
			async customerInfo() {
				let {
					code,
					data
				} = await CustomerInfo({
					cusCode: this.cusCode
				})
				if (code == 0) {
					this.$refs.secupdate[0].modelvalue = data.CusCode
					this.$refs.secupdate[1].modelvalue = data.CusName
					this.$refs.secupdate[2].modelvalue = data.CusType

					this.$refs.secupdate[3].modelvalue = data.CusAbbName
					this.$refs.secupdate[4].modelvalue = data.ParentId ? data.ParentId.split(',') : []
					this.$refs.secupdate[5].modelvalue = data.ProvinceID == 0 ? "" : data.ProvinceID + ""
					this.$refs.secupdate[6].modelvalue = data.CityID == 0 ? "" : data.CityID + ""

					this.$refs.secupdate[7].modelvalue = data.DistrictID == 0 ? "" : data.DistrictID + ""
					this.$refs.secupdate[8].modelvalue = data.Address
					this.$refs.secupdate[9].radios = data.Actived + ""
					this.$refs.secupdate[10].modelvalue = data.BusinessAddress

					this.$refs.secupdate[11].modelvalue = data.CompanyInLaw
					this.$refs.secupdate[12].modelvalue = data.WarehouseAddress
					this.$refs.secupdate[13].modelvalue = data.LicenseNo
					this.$refs.secupdate[14].modelvalue = data.LicenseMDate

					this.$refs.secupdate[15].modelvalue = data.LicenseVDate
					this.$refs.secupdate[16].modelvalue = data.VoucherNo
					this.$refs.secupdate[17].modelvalue = data.VoucherMDate
					this.$refs.secupdate[18].modelvalue = data.VoucherVDate

					this.$refs.secupdate[19].modelvalue = data.Mobile == null ? "" : data.Mobile
					this.$refs.secupdate[20].modelvalue = data.Email == null ? "" : data.Email
					this.$refs.secupdate[21].radios = data.NoStockInApp + "";
					this.$refs.secupdate[22].modelvalue = data.IsProvider + '';
					this.$refs.secupdate[23].modelvalue = data.lstParentCodes

					if (data.IsProvider) {
						this.$refs.secupdate[4].modelvalue = '';
						this.fromdataedit[4].disabled = true;
						this.fromdataedit[23].disabled = false;
					} else {
						this.$refs.secupdate[23].modelvalue = '';
						this.fromdataedit[4].disabled = false;
						this.fromdataedit[23].disabled = true;
					}

					this.$refs.secupdate2[0].modelvalue = data.FileLinkMan;
					this.$refs.secupdate2[1].modelvalue = data.FileLinkTel;
					this.$refs.secupdate2[2].modelvalue = data.FileEMail;
					this.$refs.secupdate2[3].modelvalue = data.FileReceiveAddress;
					this.$refs.secupdate2[4].radios = data.BuyFromHome + "";
					this.$refs.secupdate2[5].modelvalue = data.CompanyChargeName;
					this.$refs.secupdate2[6].modelvalue = data.CompanyChargePhone;
					this.$refs.secupdate2[7].modelvalue = data.CompanyChargeEmail;
					this.$refs.secupdate2[8].modelvalue = data.DataUploadName;
					this.$refs.secupdate2[9].modelvalue = data.DataUploadPhone;
					this.$refs.secupdate2[10].modelvalue = data.DataUploadEmail;
					this.$refs.secupdate2[11].modelvalue = data.DeliveryName;
					this.$refs.secupdate2[12].modelvalue = data.DeliverPhone;
					this.$refs.secupdate2[13].modelvalue = data.DeliveryAddress;
					this.$refs.secupdate2[14].modelvalue = data.InvoiceName;
					this.$refs.secupdate2[15].modelvalue = data.InvoicePhone;
					this.$refs.secupdate2[16].modelvalue = data.InvoiceAddress;


					this.boxsdataInvClass = data.InvClassList;

					this.getcity(data.ProvinceID)
					this.getDistrict(data.CityID)
				}
			},
			// 查看
			Look() {
				if (this.rowboo == true) {
					this.AEflig = 3
					this.dialogVisiblesedit = true
					this.EidtTitle = '查看'

					this.customerInfo()
					this.baOrganizationList()
					this.getCusType()
					this.getProvince()

					return
				}
				this.$message({
					type: 'error',
					message: '请选择要修改的数据！'
				});

			},
			// 修改
			async customerEdit(datalist, datalist2) {
				//console.log(this.$refs.addjxa[23].modelvalue)
				if (this.boxsdataInvClass.length < 0) {
					this.$message({
						type: "warning",
						message: "产品至少选一个"
					})
					return
				}
				let {
					code,
					message
				} = await CustomerEdit({
					cusCode: datalist[0].modelvalue,
					cusName: datalist[1].modelvalue,
					cusType: datalist[2].modelvalue == null ? 0 : datalist[2].modelvalue,
					actived: Number(datalist[9].radios),

					cusAbbName: datalist[3].modelvalue,
					provinceID: datalist[5].modelvalue,
					cityID: datalist[6].modelvalue,
					districtID: datalist[7].modelvalue,

					address: datalist[8].modelvalue,
					licenseNo: datalist[13].modelvalue,
					licenseVDate: datalist[15].modelvalue,
					licenseMDate: datalist[14].modelvalue,

					voucherNo: datalist[16].modelvalue,
					voucherMDate: datalist[17].modelvalue,
					voucherVDate: datalist[18].modelvalue,
					businessAddress: datalist[10].modelvalue,

					companyInLaw: datalist[11].modelvalue,
					warehouseAddress: datalist[12].modelvalue,
					parentId: datalist[4].modelvalue ? datalist[4].modelvalue.join(',') : '',

					Mobile: datalist[19].modelvalue,
					Email: datalist[20].modelvalue,
					NoStockInApp: Number(datalist[21].radios),
					IsProvider: datalist[22].modelvalue == 1 ? 1 : 0,
					lstParentCodes: datalist[23].modelvalue,

					FileLinkMan: datalist2[0].modelvalue,
					FileLinkTel: datalist2[1].modelvalue,
					FileEMail: datalist2[2].modelvalue,
					FileReceiveAddress: datalist2[3].modelvalue,
					BuyFromHome: Number(datalist2[4].radios),
					CompanyChargeName: datalist2[5].modelvalue,
					CompanyChargePhone: datalist2[6].modelvalue,
					CompanyChargeEmail: datalist2[7].modelvalue,
					DataUploadName: datalist2[8].modelvalue,
					DataUploadPhone: datalist2[9].modelvalue,
					DataUploadEmail: datalist2[10].modelvalue,
					DeliveryName: datalist2[11].modelvalue,
					DeliverPhone: datalist2[12].modelvalue,
					DeliveryAddress: datalist2[13].modelvalue,
					InvoiceName: datalist2[14].modelvalue,
					InvoicePhone: datalist2[15].modelvalue,
					InvoiceAddress: datalist2[16].modelvalue,
					invClassList: this.boxsdataInvClass,

				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '修改成功'
					});
					this.rowboo = false
					this.$parent.customerList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 删除
			async customerDelete() {
				let {
					code,
					message
				} = await CustomerDelete({
					cusCode: this.cusCode
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.rowboo = false
					this.$parent.customerList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 停用
			async customerSetActive() {
				let {
					code,
					message
				} = await BCustomerSetActive({
					cusCode: this.cusCode,
					actived: this.secTitle == "启用" ? 1 : 0
				})
				if (code == 0) {
					if (this.secTitle == "启用") {
						this.$message({
							type: 'success',
							message: '启用成功'
						});
					}
					if (this.secTitle == "停用") {
						this.$message({
							type: 'success',
							message: '停用成功'
						});
					}
					this.rowboo = false
					this.$parent.customerList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 停用/启用  合作
			async customereSetActive() {
				let {
					code,
					message
				} = await SetCooperateStatus({
					cusCode: this.cusCode,
					CooperateStatus: this.seceTitle == "合作" ? 1 : 0
				})
				if (code == 0) {
					if (this.seceTitle == "合作") {
						this.$message({
							type: 'success',
							message: '操作成功'
						});
					}
					if (this.seceTitle == "停止合同") {
						this.$message({
							type: 'success',
							message: '操作成功'
						});
					}
					this.rowboo = false
					this.$parent.customerList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			commclick(type) {
				this[type] = true
			},
			onRowClick(val) {
				// console.log(val,'val');
				this.rowboo = true
				this.UnVerifyLicenseCount = val.UnVerifyLicenseCount //待审核证照数量
				this.ValidLicenseCount = val.ValidLicenseCount //有效证照数量
				this.RejectLicenseCount = val.RejectLicenseCount //被驳回证照数量
				//console.log(val, "val")
				this.cusCode = val.CusCode
				this.CompanyID = val.CompanyID
				if (val.Actived == 1) {
					this.secImg = require('@/assets/icon/icon-stop.png')
					this.secTitle = "停用"
				}
				if (val.Actived == 0) {
					this.secImg = require('@/assets/icon/qy.png')
					this.secTitle = "启用"
				}

				if (val.CooperateStatus == 1) {
					this.secImg = require('@/assets/icon/icon-stop.png')
					this.seceTitle = "停止合作"
				}
				if (val.CooperateStatus == 0) {
					this.secImg = require('@/assets/icon/qy.png')
					this.seceTitle = "合作"
				}
			},
			adduser() {
				this.AEflig = 1
				this.activeName = 'first';
				this.dialogVisibles = true
				this.baOrganizationList()
				this.getCusType()
				this.getProvince()
				this.inventoryClassList()
			},

			async customerDownloadU8MatchTemplet() {
				let {
					data,
					code,
					message
				} = await CustomerDownloadU8MatchTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			u8DowloadImporttemplate() {
				this.customerDownloadU8MatchTemplet()
			},
			cancel() {
				this.dialogVisibles = false
			},
			province(val) {
				this.getcity(val)
				if (this.dialogVisibles) {
					this.$nextTick(() => {
						this.$refs.addjxa[6].modelvalue = ''
						this.$refs.addjxa[7].modelvalue = ''
					})
				}
				if (this.EidtTitle === '修改二级经销商档案') {
					this.$nextTick(() => {
						this.$refs.secupdate[6].modelvalue = ''
						this.$refs.secupdate[7].modelvalue = ''
					})
				}
			},
			city(val) {
				this.getDistrict(val)
				if (this.dialogVisibles) {
					this.$refs.addjxa[7].modelvalue = ''
				}
				if (this.EidtTitle === '修改二级经销商档案') {
					this.$refs.secupdate[7].modelvalue = ''
				}
			},
			dialogOK() {

				this.from.cusCode = this.$refs.addjxa[0].modelvalue
				this.from.cusName = this.$refs.addjxa[1].modelvalue
				this.from.cusType = this.$refs.addjxa[2].modelvalue

				this.from.cusAbbName = this.$refs.addjxa[3].modelvalue
				this.from.parentId = this.$refs.addjxa[4].modelvalue
				this.from.provinceID = this.$refs.addjxa[5].modelvalue
				this.from.cityID = this.$refs.addjxa[6].modelvalue

				this.from.districtID = this.$refs.addjxa[7].modelvalue
				this.from.address = this.$refs.addjxa[8].modelvalue
				this.from.actived = this.$refs.addjxa[9].radios
				this.from.businessAddress = this.$refs.addjxa[10].modelvalue

				this.from.companyInLaw = this.$refs.addjxa[11].modelvalue
				this.from.warehouseAddress = this.$refs.addjxa[12].modelvalue

				this.from.licenseNo = this.$refs.addjxa[13].modelvalue
				this.from.licenseMDate = this.$refs.addjxa[14].modelvalue
				this.from.licenseVDate = this.$refs.addjxa[15].modelvalue
				this.from.voucherNo = this.$refs.addjxa[16].modelvalue
				this.from.voucherMDate = this.$refs.addjxa[17].modelvalue
				this.from.voucherVDate = this.$refs.addjxa[18].modelvalue

				this.from.Mobile = this.$refs.addjxa[19].modelvalue
				this.from.Email = this.$refs.addjxa[20].modelvalue
				this.from.NoStockInApp = Number(this.$refs.addjxa[21].radios);

				this.from.IsProvider = this.$refs.addjxa[22].modelvalue == 1 ? 1 : 0;
				this.from.lstParentCodes = this.$refs.addjxa[23].modelvalue;


				this.from.FileLinkMan = this.$refs.addjxa2[0].modelvalue;
				this.from.FileLinkTel = this.$refs.addjxa2[1].modelvalue;
				this.from.FileEMail = this.$refs.addjxa2[2].modelvalue;
				this.from.FileReceiveAddress = this.$refs.addjxa2[3].modelvalue;
				this.from.BuyFromHome = this.$refs.addjxa2[4].radios;

				this.from.CompanyChargeName = this.$refs.addjxa2[5].modelvalue;
				this.from.CompanyChargePhone = this.$refs.addjxa2[6].modelvalue;
				this.from.CompanyChargeEmail = this.$refs.addjxa2[7].modelvalue;
				this.from.DataUploadName = this.$refs.addjxa2[8].modelvalue;
				this.from.DataUploadPhone = this.$refs.addjxa2[9].modelvalue;
				this.from.DataUploadEmail = this.$refs.addjxa2[10].modelvalue;

				this.from.DeliveryName = this.$refs.addjxa2[11].modelvalue;
				this.from.DeliverPhone = this.$refs.addjxa2[12].modelvalue;
				this.from.DeliveryAddress = this.$refs.addjxa2[13].modelvalue;
				this.from.InvoiceName = this.$refs.addjxa2[14].modelvalue;
				this.from.InvoicePhone = this.$refs.addjxa2[15].modelvalue;
				this.from.InvoiceAddress = this.$refs.addjxa2[16].modelvalue;
				this.customerAdd()
			},

			update() {
				if (this.rowboo == true) {
					this.AEflig = 2
					this.dialogVisiblesedit = true
					this.EidtTitle = '修改二级经销商档案'
					this.activeName = 'first';
					this.customerInfo()
					this.baOrganizationList()
					this.getCusType()
					this.getProvince()
					this.inventoryClassList()
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要修改的数据！'
				});

			},
			Export() {
				this.$emit('Export')
			},
			canceledit() {
				// return false

				this.dialogVisiblesedit = false
			},
			dialogOKedit() {
				if (this.AEflig == 2) {
					this.customerEdit(this.$refs.secupdate, this.$refs.secupdate2)
					this.dialogVisiblesedit = false
				} else if (this.AEflig == 3) {
					this.dialogVisiblesedit = false
				}


			},

			del() {
				if (this.rowboo == true) {
					this.dialogVisibledel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});

			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.customerDelete()
				this.dialogVisibledel = false
			},
			deactivate() {
				if (this.rowboo == true) {
					this.dialogVisibledeactivate = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要停用的数据！'
				});

			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false
			},
			dialogOKdeactivate() {
				this.customerSetActive()
				this.dialogVisibledeactivate = false
			},
			deacteivate() {
				if (this.rowboo == true) {
					this.dialogeVisibledeactivate = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要操作的数据！'
				});

			},
			dialogeOKdeactivate() {
				this.customereSetActive()
				this.dialogeVisibledeactivate = false
			},
			// 证照驳回
			LicenseRejectedClick(index) {
				this.RejectReasondialogVisibles = true
				this.RejectedIndex = index
			},
			downs(index) {
				//console.log("index", index)
				if (index == 0) {
					if (this.rowboo == true) {
						this.customerU8MatchList()
						this.dialogVisiblesU8 = true
						return
					}
					this.$message({
						type: 'error',
						message: '请选择需要配置的数据！'
					});

				}
				if (index == 1) {
					this.dialogVisiblesU8d = true
				}
			},
			LicenseRLClick(index) {
				if (index == 0) {
					// this.UnVerifyLicenseCount = val.UnVerifyLicenseCount //待审核证照数量
					// this.ValidLicenseCount = val.ValidLicenseCount //有效证照数量
					// this.RejectLicenseCount = val.RejectLicenseCount //被驳回证照数量
					if (this.rowboo == true) {
						if (this.ValidLicenseCount > 0) {
							this.LicenseRLookdialogVisibles = true
							this.status = null
							this.enabled = 1
							this.licenseGetAllLicense()
							this.Tobereviewed = false
							return
						}
						this.$message({
							type: "warning",
							message: "没有所查看的有效证照"
						})

						return
					}
					this.$message({
						type: "warning",
						message: "请选择要操作行"
					})

					//console.log(this.UnVerifyLicenseCount, this.ValidLicenseCount, this.RejectLicenseCount);
				}
				if (index == 1) {
					if (this.rowboo == true) {
						if (this.UnVerifyLicenseCount > 0) {
							this.status = 0
							this.enabled = 0
							this.licenceTitle = "审核有效证照"
							this.licenseGetAllLicense()
							this.LicenseRLookdialogVisibles = true
							this.Tobereviewed = true
							return
						}
						this.$message({
							type: "warning",
							message: "没有审核有效证照"
						})
						return
					}
					this.$message({
						type: "warning",
						message: "请选择要操作行"
					})
				}
				if (index == 2) {
					if (this.rowboo == true) {
						if (this.RejectLicenseCount > 0) {
							this.rejectdialogVisibles = true
							this.licenseGetRejectLicense()
							return
						}
						this.$message({
							type: "warning",
							message: "没有驳回相关数据"
						})
						return
					}
					this.$message({
						type: "warning",
						message: "请选择要操作行"
					})

				}
			},
			// 驳回
			async OpenAccountReject(OAID) {
				let {
					code,
					data,
					message
				} = await OpenAccountReject({
					OAID: OAID,
					RejectReason: this.RejectReasonPic
				})
				if (code == 0) {
					this.$message.success("驳回成功")
					this.licenseGetAllLicense()
				} else {
					this.$message.warning(message)
				}
			},
			// 驳回列表
			async licenseGetRejectLicense() {
				let {
					code,
					data,
					message
				} = await LicenseGetRejectLicense({
					cusCode: this.cusCode,
					cusType: "经销商",
					pageSize: this.RejectpageSize,
					pageIndex: this.Rejectpageindex
				})
				if (code == 0) {
					this.rejecttotal = data.Count
					this.rejectTable = data.data
				}
			},
			// 营业执照驳回明细接口
			async licenseGetBusinessLicense() {
				let {
					code,
					data,
					message
				} = await LicenseGetBusinessLicense({
					ID: this.getID
				})
				if (code == 0) {
					this.BusdetailsTableData = null
					this.RedetailsTableData = null
					this.CommitmentLetterData = null
					this.filecontactData = null
					this.openaccountData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
					this.BLdetailsTableData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 医疗器械经营许可证驳回明细接口
			async licenseGetBusinessPermission() {
				let {
					code,
					data,
					message
				} = await LicenseGetBusinessPermission({
					ID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.CommitmentLetterData = null
					this.openaccountData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
					this.BusdetailsTableData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 第二类医疗器械备案凭证驳回明细接口
			async licenseGetBusinessRecord() {
				let {
					code,
					data,
					message
				} = await LicenseGetBusinessRecord({
					ID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.BusdetailsTableData = null
					this.CommitmentLetterData = null
					this.openaccountData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
					this.RedetailsTableData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表承诺书
			async OpenAccountGetCommitmentLetter() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetCommitmentLetter({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
					this.CommitmentLetterData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表开户许可证
			async OpenAccountGetOpenAccount() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetOpenAccount({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = data
					this.CommitmentLetterData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表经销商信息表
			async OpenAccountGetCusInfo() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetCusInfo({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = null
					this.CommitmentLetterData = null
					this.filecontactData = null
					this.cusinfoData = data
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表关联申明
			async OpenAccountGetAffiliateStatement() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetAffiliateStatement({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = null
					this.CommitmentLetterData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表业务员授权书
			async OpenAccountGetSalerBusinessAuthority() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetSalerBusinessAuthority({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = null
					this.CommitmentLetterData = null
					this.filecontactData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = data
					this.affiliatestatementData = null
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 驳回列表联系信息
			async OpenAccountGetFileContact() {
				let {
					code,
					data,
					message
				} = await OpenAccountGetFileContact({
					OAID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = null
					this.openaccountData = null
					this.filecontactData = data
					this.CommitmentLetterData = null
					this.cusinfoData = null
					this.salerbusinessauthorityData = null
					this.affiliatestatementData = null
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},

			rejectdonRowClick(val) {
				console.log(val);
				this.getID = val.ID
				this.detailsTitle = val.LicenseType
				if (val.LicenseType == "营业执照") {
					this.licenseGetBusinessLicense()
				}
				if (val.LicenseType == "医疗器械经营许可证") {
					this.licenseGetBusinessPermission()
				}
				if (val.LicenseType == "第二类医疗器械备案凭证") {
					this.licenseGetBusinessRecord()
				}
				if (val.LicenseType == "承诺函") {
					this.OpenAccountGetCommitmentLetter()
				}
				if (val.LicenseType == "开户许可证") {
					this.OpenAccountGetOpenAccount()
				}
				if (val.LicenseType == "经销商信息表") {
					this.OpenAccountGetCusInfo()
				}
				if (val.LicenseType == "关联申明") {
					this.OpenAccountGetAffiliateStatement()
				}
				if (val.LicenseType == "业务员授权书") {
					this.OpenAccountGetSalerBusinessAuthority()
				}
				if (val.LicenseType == "联系信息") {
					this.OpenAccountGetFileContact()
				}

			},
			rejecthandleCurrentChange(pageindex) {
				this.Rejectpageindex = pageindex
				this.licenseGetRejectLicense()
			},
			rejecthandleSizeChange(paegSzie) {
				this.RejectpageSize = paegSzie
				this.licenseGetRejectLicense()
			},
			// 查看各种状态证照
			async licenseGetAllLicense() {
				let {
					data,
					code,
					message
				} = await LicenseGetAllLicense({
					cusCode: this.cusCode,
					cusType: "经销商",
					status: this.status,
					enabled: this.enabled
				})
				if (code == 0) {
					this.lflag = true
					this.license = data.license //营业执照部分
					this.permission = data.permission //医疗器械经营许可证部分
					this.record = data.record //第二类医疗器械备案凭证部分
					if (data.openaccount || data.cusinfo ||
						data.salerbusinessauthority || data.commitmentletter ||
						data.affiliatestatement || data.filecontact
					) {
						this.RejectStatus = true
					} else {
						this.RejectStatus = false
					}
					if (data.openaccount == null) {
						this.LicenseRejected[0].flag = false
					} else {
						this.LicenseRejected[0].flag = true
					}
					if (data.cusinfo == null) {
						this.LicenseRejected[1].flag = false
					} else {
						this.LicenseRejected[1].flag = true
					}
					if (data.salerbusinessauthority == null) {
						this.LicenseRejected[2].flag = false
					} else {
						this.LicenseRejected[2].flag = true
					}
					if (data.commitmentletter == null) {
						this.LicenseRejected[3].flag = false
					} else {
						this.LicenseRejected[3].flag = true
					}
					if (data.affiliatestatement == null) {
						this.LicenseRejected[4].flag = false
					} else {
						this.LicenseRejected[4].flag = true
					}
					if (data.filecontact == null) {
						this.LicenseRejected[5].flag = false
					} else {
						this.LicenseRejected[5].flag = true
					}
					this.openaccount = data.openaccount //开户许可证
					this.cusinfo = data.cusinfo //经销商信息表
					this.salerbusinessauthority = data.salerbusinessauthority //业务员授权书
					this.commitmentletter = data.commitmentletter //承诺函
					this.affiliatestatement = data.affiliatestatement //关联申明
					this.filecontact = data.filecontact //联系信息
					this.providerDocumentation.lstAttachment = data.providerDocumentation;
				} else {
					this.$message.warning(message)
				}
			},
			async licenseRejectBusinessLicense() {
				let {
					code,
					data,
					message
				} = await LicenseRejectBusinessLicense({
					blid: this.license.BLID,
					RejectReason: this.RejectReasonLicense
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.RejectReasonLicense = ''
					this.licenseGetAllLicense()
					this.$parent.customerList()
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "营业执照驳回结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			async licenseRejectBusinessPermission() {
				let {
					code,
					data,
					message
				} = await LicenseRejectBusinessPermission({
					bpid: this.permission.BPID,
					RejectReason: this.RejectReasonPermission
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.RejectReasonPermission = ''
					this.licenseGetAllLicense()
					this.$parent.customerList()
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "医疗器械经营许可证驳回结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			async licenseRejectBusinessRecord() {
				let {
					code,
					data,
					message
				} = await LicenseRejectBusinessRecord({
					brid: this.record.BRID,
					RejectReason: this.RejectReasonRecord
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.RejectReasonRecord = ''
					this.licenseGetAllLicense()
					this.$parent.customerList()
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "第二类医疗器械备案凭证驳回结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			async licenseVerifyLicense() {
				let BLID = ''
				let BPID = ''
				let BRID = ''
				let OAIDs = [] //底部五张证照和联系信息的ID
				if (this.license) {
					BLID = this.license.BLID
				}
				if (this.permission) {
					BPID = this.permission.BPID
				}
				if (this.record) {
					BRID = this.record.BRID
				}
				if (this.openaccount) {
					OAIDs.push(this.openaccount.OAID)

				}
				if (this.salerbusinessauthority) {
					OAIDs.push(this.salerbusinessauthority.OAID)
				}
				if (this.cusinfo) {
					OAIDs.push(this.cusinfo.OAID)

				}
				if (this.commitmentletter) {
					OAIDs.push(this.commitmentletter.OAID)
				}
				if (this.affiliatestatement) {
					OAIDs.push(this.affiliatestatement.OAID)
				}
				if (this.filecontact) {
					OAIDs.push(this.filecontact.OAID)
				}
				let {
					code,
					data,
					message
				} = await LicenseVerifyLicense({
					blid: BLID,
					bpid: BPID,
					brid: BRID,
					OAIDs: OAIDs
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.licenseGetAllLicense()
					this.$parent.customerList()
					this.Li
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "全部审核结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			See(par) {
				if (par.Extension == 'jpg' || par.Extension == 'png' || par.Extension == 'gif') {
					this.imgShow = true
					this.imgsrc = par.FilePath
				} else if (par.Extension == 'pdf') {
					window.open(par.FilePath, '_blank')
				} else {
					window.open(par.FilePath || par.FileUrl, '_blank')
				}
			},
			businessLicense() {
				this.licenseBHdialogVisibles = true
			},
			medicalEquipment() {
				this.permissionBHdialogVisibles = true
			},
			CLLMDFCR() {
				this.recordBHdialogVisibles = true
			},
			AllReview() {
				this.licenseVerifyLicense()
			},
			cancelU8() {
				this.dialogVisiblesU8 = false
			},
			dialogOKeditU8() {
				this.dialogVisiblesU8 = false
			},
			cancelU8d() {
				this.dialogVisiblesU8d = false
			},
			dialogOKeditU8d() {
				this.dialogVisiblesU8d = false
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			LicenseRLookcancel() {
				this.LicenseRLookdialogVisibles = false
			},
			LicenseRLookdialogOK() {
				this.LicenseRLookdialogVisibles = false
			},
			licenseBHcancel() {
				this.licenseBHdialogVisibles = false
			},
			licenseBHdialogOK() {
				this.licenseRejectBusinessLicense()
				this.licenseBHdialogVisibles = false
			},
			permissionBHcancel() {
				this.permissionBHdialogVisibles = false
			},
			permissionBHdialogOK() {
				this.licenseRejectBusinessPermission()
				this.permissionBHdialogVisibles = false
			},
			recordBHcancel() {
				this.recordBHdialogVisibles = false
			},
			recordBHdialogOK() {
				this.licenseRejectBusinessRecord()
				this.recordBHdialogVisibles = false
			},
			rejectcancel() {
				this.rejectdialogVisibles = false
			},
			rejectdialogOK() {
				this.rejectdialogVisibles = false
			},
			RejectReasoncancel() {
				this.RejectReasondialogVisibles = false
			},
			RejectReasondialogOK() {
				if (this.RejectedIndex == 0) {
					this.OpenAccountReject(this.openaccount.OAID)
				} else if (this.RejectedIndex == 1) {
					this.OpenAccountReject(this.cusinfo.OAID)
				} else if (this.RejectedIndex == 2) {
					this.OpenAccountReject(this.salerbusinessauthority.OAID)
				} else if (this.RejectedIndex == 3) {
					this.OpenAccountReject(this.commitmentletter.OAID)
				} else if (this.RejectedIndex == 4) {
					this.OpenAccountReject(this.affiliatestatement.OAID)
				} else if (this.RejectedIndex == 5) {
					this.OpenAccountReject(this.filecontact.OAID)
				}
				this.RejectReasondialogVisibles = false
			},
			handleCheckedAddChange(e) {
				this.$refs.addjxa[4].modelvalue = '';
				this.fromdataadd[4].disabled = e == '1' ? true : false;
				this.$refs.addjxa[23].modelvalue = '';
				this.fromdataadd[23].disabled = e == '1' ? false : true;
			},
			handleCheckedEditChange(e) {
				this.$refs.secupdate[4].modelvalue = '';
				this.fromdataedit[4].disabled = e == '1' ? true : false;
				this.$refs.secupdate[23].modelvalue = '';
				this.fromdataedit[23].disabled = e == '1' ? false : true;
			}
		},
		watch: {
			dialogVisibles: {
				handler(newList, oldList) {
					if (newList == false) {
						this.$refs.addjxa.map((item, index) => {
							if (index == 9) {
								item.radio = "1"
							}
							item.modelvalue = ""
						})
						this.$refs.addjxa2.map((item, index) => {
							if (index == 4) {
								item.radio = "1"
							}
							item.modelvalue = ""
						})
					}
				},
				deep: true
			},
			rejectdialogVisibles: {
				handler(newList, oldList) {
					if (newList) {
						this.BusdetailsTableData = null
						this.RedetailsTableData = null
						this.CommitmentLetterData = null
						this.filecontactData = null
						this.openaccountData = null
						this.cusinfoData = null
						this.salerbusinessauthorityData = null
						this.affiliatestatementData = null
						this.BLdetailsTableData = null
						this.detailsTitle = ''
					}
				},
				deep: true
			},

			EidtTitle: {
				handler(newVal, oldVal) {
					if (newVal == '查看') {
						this.fromdataedit.forEach((item, index) => {
							item.disabled = true
						})
						this.fromdataedit2.forEach((item, index) => {
							item.disabled = true
						})
					} else if (newVal == '修改二级经销商档案') {
						this.fromdataedit.forEach((item, index) => {
							item.disabled = false
						})
						this.fromdataedit2.forEach((item, index) => {
							item.disabled = false
						})
					}
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.Code {
		width: 100%;
	}

	.type {
		width: 98.6%;
		border: 1px solid #e6e6e6;
		font-size: 17px;
		color: #333333;
		font-weight: 500;
		padding: 10px 10px 10px 0;
		margin: 0 auto;

		.type-top {
			width: 100%;
			border-bottom: 1px solid #e6e6e6;
			font-weight: bold;
			color: #333333;
			font-size: 14px;
			text-indent: 16px;
			line-height: 16px;
			padding-bottom: 10px;

			.type-top-left {
				width: 3px;
				height: 16px;
				display: inline-block;
				background-color: #e71d43;
				float: left;
			}
		}

		.type-text {
			margin-top: 12px;
		}

		.CodeText {
			display: inline-block;
			width: 430px;
			margin-left: 30px;
			font-size: 14px;
			font-weight: 500;
			// border: 1px solid red;
			color: #999999;
			margin-top: 12px;
			position: relative;

			.imgBox {
				display: inline-block;
				width: 96px;
				height: 96px;
				border: 1px solid #e6e6e6;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}

			span {
				display: inline-block;
				color: #333333;
				font-weight: 500;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}
		}
	}

	.LicenseRfrom {
		width: 100%;
		height: 600px;
		overflow: scroll;
	}

	.detailedCss {
		min-width: 100px;
		max-width: 200px;
		height: 32px;
		background-color: #fce8ec;
		border: 1px solid #e71d43;
		color: #e71d43;
		font-size: 14px;
		text-align: center;
		line-height: 32px;
		margin: 10px 10px 10px 0;
	}

	.imgTop {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 75px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop2 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 145px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop3 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 175px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop4 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 130px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}
</style>